import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../utils/api';
import { FetchFileParams } from './types';

export const fetchS3File = createAsyncThunk(
  'file/fetchS3File',
  async ({ filePath, fileFormat = 'blob' }: FetchFileParams, { rejectWithValue }) => {
    try {
      const response = await apiCall<Blob>(
        'get',
        `/api/fetch-s3-file/?file_path=${encodeURIComponent(filePath)}&file_format=${fileFormat}`,
        undefined,
        undefined,
        'blob'
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch file');
    }
  }
);
